import type { Immutable } from 'immer';
import { SAVED_VIDEO_STATE } from '@studio/constants/library';
import type { Shared } from '@studio/types';

const isProcessing = (media: Immutable<Shared.Library.BaseMediaItem> | Shared.Library.BaseMediaItem): boolean => {
  const mediaState = media.state.toLowerCase();
  return (
    mediaState === SAVED_VIDEO_STATE.STARTED ||
    mediaState === SAVED_VIDEO_STATE.REPUBLISH_PENDING ||
    mediaState === SAVED_VIDEO_STATE.PARTIAL_DELETE_PENDING ||
    mediaState === SAVED_VIDEO_STATE.CONTENT_AVAILABLE
  );
};

export default isProcessing;
